import { TargetMap } from 'class-transformer'

export class Banner {
  constructor(
    public title: string,
    public brief: string,
    public fullScreen: boolean = false,
    public carousel: BannerCarousel[] | null
  ) {}
}

export class BannerCarousel {
  constructor(
    public video: string,
    public cover: string,
    public mobileCover: string,
    public title: string,
    public titleColor: string,
    public brief: string,
    public briefColor: string,
  ) {}
}

export const BannerTarget: TargetMap[] = [
  {
    target: Banner,
    properties: {
      carousel: BannerCarousel,
    },
  },
]
